// extracted by mini-css-extract-plugin
export default {"bundleFormslistWrapper":"styles_bundleFormslistWrapper__Ln+yc"};